import { action, createRequestTypes } from './base';

export const stActionTypes = {
  CREATE_ST: createRequestTypes('CREATE_ST'),
  GET_ST: createRequestTypes('GET_ST'),
  GET_ST_BY_ID: createRequestTypes('GET_ST_BY_ID'),
  UPDATE_ST: createRequestTypes('UPDATE_ST'),
  UPDATE_ST_STATUS: createRequestTypes('UPDATE_ST_STATUS'),
  DELETE_ST: createRequestTypes('DELETE_ST'),
  ST_SHORT_CLOSE: createRequestTypes('ST_SHORT_CLOSE'),
  UPDATE_ST_WORKFLOW_STEP: createRequestTypes('UPDATE_ST_WORKFLOW_STEP'),
};

/**
 *
 */
class STActions {
  /**
   * @param {*} payload
   * @param {*} callback
   * @param withApproval
   * @return
   */
  createSt = (payload, callback, withApproval) => action(stActionTypes.CREATE_ST.REQUEST, {
    payload,
    callback,
    withApproval,
  })

  /**
   *
   * @param {*} createStLoading
   * @return
   */
  createStLoading = (createStLoading) => action(stActionTypes.CREATE_ST.LOADING, {
    createStLoading,
  })

  /**
   * @param {*} payload
   * @param {*} callback
   * @param withApproval
   * @return
   */
  updateSt = (payload, callback, withApproval) => action(stActionTypes.UPDATE_ST.REQUEST, {
    payload,
    callback,
    withApproval,
  })

  /**
   *
   * @param {*} updateStLoading
   * @return
   */
  updateStLoading = (updateStLoading) => action(stActionTypes.UPDATE_ST.LOADING, {
    updateStLoading,
  })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    updateStStatus = (payload, callback) => action(stActionTypes.UPDATE_ST_STATUS.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} updateStStatusLoading
     * @return
     */
    updateStStatusLoading = (updateStStatusLoading) => action(stActionTypes.UPDATE_ST_STATUS.LOADING, {
      updateStStatusLoading,
    })

    /**
     * @param {*} page
     * @param {*} tenantId
     * @param {*} stId
     * @param limit
     * @param searchKeyword
     * @param callback
     * @param adjustmentEntityType
     * @return
     */
    getSt = (tenantId, stId, page, limit, searchKeyword, receivingStatus, status, department, callback) => action(
      stActionTypes.GET_ST.REQUEST, {
        tenantId, stId, page, limit, searchKeyword, receivingStatus, status, department, callback,
      },
    )

    /**
     * @param getStLoading
     * @return {{type: *}}
     */
     getStLoading = (getStLoading) => action(stActionTypes.GET_ST.LOADING, {
       getStLoading,
     })

     /**
      * @param sts
      * @param lowOrgProducts
      * @return {{type: *}}
      */
     getStSuccess = (sts) => action(stActionTypes.GET_ST.SUCCESS, {
       sts,
     })

    /**
     * @param tenantId
     * @param stId
     * @return {{type: *}}
     */
    getStById = (tenantId, stId) => action(stActionTypes.GET_ST_BY_ID.REQUEST, {
      tenantId,
      stId,
    })

    /**
     *
     * @param getStByIdLoading
     * @return {{type: *}}
     */
    getStByIdLoading = (getStByIdLoading) => action(stActionTypes.GET_ST_BY_ID.LOADING, {
      getStByIdLoading,
    })

    /**
     *
     * @param selectedSt
     * @return {{type: *}}
     */
    getStByIdSuccess = (selectedSt) => action(stActionTypes.GET_ST_BY_ID.SUCCESS, {
      selectedSt,
    })

    /**
     * @param deleteStLoading
     * @param {*} updateStLoading
     * @return
     */
    deleteStLoading = (deleteStLoading) => action(stActionTypes.DELETE_ST.LOADING, {
      deleteStLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
      deleteSt = (payload, callback) => action(stActionTypes.DELETE_ST.REQUEST, {
        payload,
        callback,
      })

    /**
     * @param createStShortCloseLoading
     * @return
     */
    createStShortCloseLoading = (createStShortCloseLoading) => action(stActionTypes.ST_SHORT_CLOSE.LOADING, {
      createStShortCloseLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createStShortClose = (payload, callback) => action(stActionTypes.ST_SHORT_CLOSE.REQUEST, {
      payload,
      callback,
    })

    updateSTWorkflowStep = (payload, callback) => action(stActionTypes.UPDATE_ST_WORKFLOW_STEP.REQUEST, {
      payload, callback,
    })

    /**
     *
     * @param updateSTWorkflowStepLoading
     * @return {{type: *}}
     */
    updateSTWorkflowStepLoading = (updateSTWorkflowStepLoading) => action(stActionTypes.UPDATE_ST_WORKFLOW_STEP.LOADING, {
      updateSTWorkflowStepLoading,
    })
}

export default new STActions();
